import { render } from "./SelectedCarPlaceholder.vue?vue&type=template&id=371f4b0d&ts=true"
import script from "./SelectedCarPlaceholder.vue?vue&type=script&lang=ts"
export * from "./SelectedCarPlaceholder.vue?vue&type=script&lang=ts"

import "./SelectedCarPlaceholder.vue?vue&type=style&index=0&id=371f4b0d&lang=css"

import exportComponent from "/usr/home/demon/projects/driven/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__